import axios from "axios"

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL })

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`
  }

  return req
})

export const fetchPosts = (page) => API.get(`/posts?page=${page}&perPage=6`)
export const createPost = (newPost) => API.post("/posts", newPost)
export const fetchPostsBySearch = (searchQuery) =>
  API.get(
    `/posts/search?searchQuery=${searchQuery.search || "none"}&tags=${
      searchQuery.tags
    }&perPage=6`
  )
export const updatePost = (id, updatedPost) =>
  API.patch(`posts/${id}`, updatedPost)
export const deletePost = (id) => API.delete(`posts/${id}`)
export const likePost = (id) => API.patch(`posts/${id}/likePost`)

export const signIn = (formData) => API.post("/user/signin", formData)
export const signUp = (formData) => API.post("/user/signup", formData)

// Game Score APIs
export const saveGameScore = (scoreData) => API.post("/gamescores", scoreData)
export const getGameScores = (params) => API.get(`/gamescores?${new URLSearchParams(params)}`)
export const getTopScores = (gameType, limit = 10) => API.get(`/gamescores/top/${gameType}?limit=${limit}`)
export const getUserScores = (params) => API.get(`/gamescores/user?${new URLSearchParams(params)}`)
export const getGuestScores = (sessionId, params) => API.get(`/gamescores/guest/${sessionId}?${new URLSearchParams(params)}`)
